import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBasketShopping, faBars } from "@fortawesome/pro-regular-svg-icons";
import { faRightFromBracket } from "@fortawesome/pro-solid-svg-icons";
import Logo from "../assets/img/logo.svg";
import LogoMeae from "../assets/img/logo_meae.svg";
import UkraineFlag from "../assets/img/ukraine.svg";
import FundedHag from "../assets/img/fundedby_hag.svg";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Auth from "../services/Auth";
import Modal from "./ui/Modal";
import BasketInformation from "../pages/shop/BasketInformation";
import { useState, useEffect } from "react";
import { fetchOrder } from "../features/basket/basketSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const authUser = useSelector((state) => state.auth);
  const [openModalBasket, setOpenModalBasket] = useState(false);
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.basket);
  const { t } = useTranslation();

  useEffect(() => {
    if (openModalBasket === true) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [openModalBasket]);

  useEffect(() => {
    if (authUser.user.order && authUser.user.order !== "null") {
      dispatch(fetchOrder(authUser.user.order));
      if (!authUser.user.isSwitchedUser) {
        //console.info('create localStorage "order"', authUser.user.order);
        window.localStorage.setItem("order", authUser.user.order);
      }
    }
  }, []);

  return (
    <>
      {authUser.user.isSwitchedUser && (
        <div className="text-xs lg:text-sm lg:flex bg-bioport-orange p-4 text-center text-white items-center justify-center">
          Vous êtes connecté en tant que
          <span className="text-white ml-2">{authUser.user.username}</span>
          <span className="px-3">|</span>
          <span>
            <FontAwesomeIcon
              icon={faRightFromBracket}
              className="text-white hover:scale-110 cursor-pointer"
              onClick={() => Auth.switchOriginalUser()}
            />
          </span>
        </div>
      )}
      <div className="bg-white p-6 text-sm shadow-md shadow-gray-300/30">
        <div className="flex justify-between container m-auto">
          <div className="flex items-center">
            <a
              href="https://bioport-logistique.com"
              title="BIOPORT Logistique"
              target="_blank"
            >
              <img
                className="h-20 lg:h-10 m-auto w-auto"
                src={Logo}
                alt="BIOPORT Logistique"
              />
            </a>
            <img
              className="ml-5 h-8 lg:h-16"
              src={LogoMeae}
              alt="Ministère de l'Europe et des Affaires Etrangères"
            />
            <img
              className="ml-5 h-8 lg:h-16 mt-2"
              src={FundedHag}
              alt="Funded by European Union"
            />
          </div>

          <div className="flex items-center">
            <span
              className={`flex items-center cursor-pointer mx-6 rounded-lg py-4 px-4 ${
                basket && basket.entities.length > 0
                  ? "text-white bg-bioport-orange hover:bg-bioport-orange-light"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
              title={t("shop.basket.title")}
              onClick={() => {
                setOpenModalBasket(!openModalBasket);
              }}
            >
              <FontAwesomeIcon icon={faBasketShopping} className="text-lg" />
              <span className="text-xs ml-3 font-bold">
                {basket?.entities?.length || 0}
              </span>
            </span>
            <Link
              to="/settings/account"
              className="flex items-center cursor-pointer duration-300 transition"
              title="MENU"
            >
              <FontAwesomeIcon
                icon={faBars}
                className="text-2xl text-gray-600 hover:text-bioport-blue-dark"
              />
            </Link>
          </div>
        </div>
      </div>
      {openModalBasket && (
        <Modal
          showModal={openModalBasket}
          setShowModal={setOpenModalBasket}
          title={t("shop.basket.title")}
          withSubmitButton={false}
          footer={false}
          center={
            basket?.entities && Object.values(basket.entities).length <= 3
          }
        >
          <BasketInformation
            basket={basket}
            setOpenModalBasket={setOpenModalBasket}
          />
        </Modal>
      )}
    </>
  );
};

export default Navbar;
